import { ActionsList } from "./ActionsList";

/** The Actions tab: actions owned by the current org. */
export function OrgActions() {
  return <ActionsList scope="org" />;
}
